import { useContext } from 'react';
import { useStore } from 'zustand';

import { OutrightsCouponContext } from '../context';
// TODO: rename outright-markets to outrights-coupon
import { type OutrightsCouponState } from '../interfaces/outright-markets.interface';

export function useOutrightsCouponContext<T>(
  selector: (state: OutrightsCouponState) => T,
  equalityFn?: (left: T, right: T) => boolean,
): T {
  const store = useContext(OutrightsCouponContext);
  if (!store) throw new Error('Missing OutrightsCouponContext.Provider in the tree');
  return useStore(store, selector, equalityFn);
}
